(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomSettingController', CustomSettingController);

    CustomSettingController.$inject = ['$rootScope', '$scope', '$state', 'entity', 'Company', 'CompanyCustom', 'AlertService', '$translate', '$translatePartialLoader', 'Principal'];

    function CustomSettingController($rootScope, $scope, $state, entity, Company, CompanyCustom, AlertService, translate, translatePartialLoader, Principal) {
        var vm = this;

        vm.save = save;
        vm.changeCapacityViewMode = changeCapacityViewMode;
        vm.scope = $scope;
        translatePartialLoader.addPart('customSetting');
        translatePartialLoader.addPart('global');
        translatePartialLoader = translate.refresh();

        vm.company = entity;

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.sys_birthdate = false;
        vm.sys_national_code = false;
        vm.sysBirthdateChange = sysBirthdateChange;
        vm.sysNationalCodeChange = sysNationalCodeChange;

        if ($state.current.parent == 'supplierPanel-v2')
            $rootScope.$broadcast('hideNavBar');


        if (vm.company.customSettingObject != undefined) {
            vm.company.customSettingObject.isClientEmailRequired = (entity.customSettingObject.isClientEmailRequired == true);
            vm.company.customSettingObject.canReserveByClient = (entity.customSettingObject.canReserveByClient != false);
            vm.company.customSettingObject.canReserveByWidget = (entity.customSettingObject.canReserveByWidget != false);
            vm.capacityViewMode = (vm.company.customSettingObject.capacityViewMode === 'SHOW');
            // vm.customSettingObject.companyCustomerCustomSettings.fields.find()


        } else {
            vm.company.customSettingObject = {};
            vm.company.customSettingObject.canReserveByClient = null;
            vm.company.customSettingObject.canReserveByClient = true;
            vm.company.customSettingObject.canReserveByWidget = null;
            vm.company.customSettingObject.canReserveByWidget = true;
            vm.capacityViewMode = (vm.company.customSettingObject.capacityViewMode === 'SHOW');
        }
        if(!vm.company.customSettingObject.companyCustomerCustomSettings) {
            vm.company.customSettingObject.companyCustomerCustomSettings = {
                fields: [
                    { name:"sys_birthdate",required: false, fieldType:"Date" ,label:"تاریخ تولد" },
                    { name:"sys_national_code",required: false, fieldType:"TextBox" ,label:"کدملی" }
                ]
            }
        }

        angular.forEach(vm.company.customSettingObject.companyCustomerCustomSettings.fields, function (field) {
            if(field.name === "sys_birthdate") vm.sys_birthdate = field.required
            if(field.name === "sys_national_code") vm.sys_national_code = field.required
        })



        function save() {

            if (vm.scope.editForm.$valid) {
                vm.changeCapacityViewMode(vm.capacityViewMode);
                vm.isSaving = true;
                if (vm.company.id !== null) {
                    // Company.update(vm.company, onSaveSuccess, onSaveError);
                    CompanyCustom.companyCustomSettingField().save(vm.company.customSettingObject, onSaveSuccess, onSaveError);
                } else {
                    //Company.save(vm.company, onSaveSuccess, onSaveError);
                }
            }
        }

        function changeCapacityViewMode(capacityViewMode) {
            if (capacityViewMode == false) {
                vm.company.customSettingObject.capacityViewMode = "HIDE";
                vm.capacityViewMode = false;
            } else {
                vm.company.customSettingObject.capacityViewMode = "SHOW";
                vm.capacityViewMode = true;
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);

            if (result)
                vm.company = result;

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }


        function sysBirthdateChange(e) {
           var item = vm.company.customSettingObject.companyCustomerCustomSettings.fields.find(function(field) {
                return field.name === 'sys_birthdate';
            });
            item.required = vm.sys_birthdate
        }
        function sysNationalCodeChange(e) {
             var item = vm.company.customSettingObject.companyCustomerCustomSettings.fields.find(function(field) {
                return field.name === 'sys_national_code';
            });
            item.required = vm.sys_national_code;
            item.fieldType = "TextBox";
        }
    }

})();
